module.exports = __webpack_public_path__ + "34b277357859fab3e7ef5b0ce87d4f7e.jpg";